import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Label, Container } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { APP_NAME } from "../../config"

import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { getDistrictOptions } from "../../store/options/actions"
import { isArray } from "lodash"
import { MDBDataTable } from "mdbreact"

const Category = () => {
  document.title = `category | ${APP_NAME}`

  const { districts } = useSelector(state => state.Options)

  const dispatch = useDispatch()

  const [master, setMaster] = useState({})

  const [select, setSelect] = useState({})

  const [rows, setRows] = useState([])

  useEffect(() => {
    //? default kerala districts option
    dispatch(getDistrictOptions({ id: 19 }))
  }, [dispatch])

  const getTableRows = () => {}

  const handleChange = e => {
    const { name, value } = e.target
    setMaster({ ...master, [name]: value })
  }

  const handleSelect = (e, name) => {
    const value = e ? (isArray(e) ? e.map(item => item.value) : e.value) : null
    setSelect(pre => ({ ...pre, [name]: e }))
    setMaster(pre => ({ ...pre, [name]: value }))
  }

  const handleReset = () => {
    setMaster({})

    setSelect({})
  }

  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        width: 150,
      },
      {
        label: "Date",
        field: "date",
        width: 150,
      },
      {
        label: "District",
        field: "districtName",
        width: 150,
      },
      {
        label: "Name",
        field: "name",
        width: 150,
      },
      {
        label: "Actions",
        field: "options",
        sort: "desc",
        width: 400,
      },
    ],
    rows,
  }

  console.log("master :>> ", master)

  console.log("select :>> ", select)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Home" breadcrumbItem="Category" />

          <Row>
            <Card>
              <CardBody>
                <AvForm
                  onValidSubmit={() => {
                    // handleSubmit()
                  }}
                >
                  <Row>
                    <Col md="3">
                      <div className="mb-3">
                        <Label>District</Label>
                        <Select
                          name="Domain"
                          type="text"
                          options={districts}
                          value={select.district || null}
                          onChange={e => handleSelect(e, "district")}
                          errorMessage="Enter Category"
                          menuPosition="fixed"
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="mb-3">
                        <Label>Name</Label>
                        <AvField
                          name="name"
                          className="form-control"
                          type="text"
                          onChange={handleChange}
                          value={master.name}
                          placeholder="Name"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="mb-3" style={{ paddingTop: "25px" }}>
                        <Button
                          color={master?.id ? "warning" : "primary"}
                          type="submit"
                        >
                          {master?.id ? "Update" : "Submit"}
                        </Button>
                        <Button
                          onClick={handleReset}
                          style={{ marginLeft: "10px" }}
                          color="danger"
                          type="reset"
                        >
                          Reset
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    id="TaxRatesid"
                    bordered
                    responsive
                    searching={true}
                    entries={20}
                    disableRetreatAfterSorting={true}
                    data={data}
                  ></MDBDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Category
